<template>
  <div v-show="isVisible">
    <div class="title">Описание услуги:</div>
    <div class="dop-info">
      <div class="fieldset">
        <label class="fieldset-title">Категория</label>
        <fieldset>
          <select v-if="isNew" v-model="newDowntimeService.category">
            <option disabled :value="null">-- Выбрать --</option>
            <option v-for="category in downtimeCategories" :value="category">
              {{ category.name }}
            </option>
          </select>
          <select v-else v-model="downtimeService.category">
            <option disabled :value="null">-- Выбрать --</option>
            <option v-for="category in downtimeCategories" :value="category">
              {{ category.name }}
            </option>
          </select>
        </fieldset>
      </div>
      <div class="fieldset day-idle-city">
        <div class="switch">
          <span class="city-select-item" :class="{active: inKzn}">Казань</span>
          <div class="switch_bg" @click="inKzn = !inKzn">
            <span :class="{'location-right': !inKzn}"></span>
          </div>
          <span class="city-select-item" :class="{active: !inKzn}">Другой город</span>
        </div>
      </div>
    </div>
    <div class="buttons">
      <button type="button" class="save-button" @click="saveChanges">Сохранить</button>
    </div>
  </div>
</template>
<script>
    import api from '@/api'
    import utils from '@/utils'

    export default {
  name: 'DowntimeService',
  props: ['isVisible', 'index', 'isNew', 'count', 'orderDateTime'],

  data () {
    return {
      newDowntimeService: {
        type: 'OrderToDowntime',
        pathToClass: 'ru.itbrick.shustrikoffcrm.beans.OrderToDowntime'
      },

      downtimeService: {},

      downtimeCategories: []
    }
  },

  computed: {
    currentService: {
      get () {
        return this.isNew
          ? this.newDowntimeService
          : this.downtimeService
      },

      set (service) {
        if (this.isNew) {
          this.newDowntimeService = service
        } else {
          this.downtimeService = service
        }
      }
    },

    inKzn: {
      get () {
        return this.currentService.inKzn
      },

      set (value) {
        this.currentService.inKzn = value
      }
    }
  },

  watch: {
    isVisible (val) {
      if (val) {
        if (!this.isNew) { this.downtimeService = Object.assign({}, this.$store.getters.groupedServices[this.index][0]) } else {
          this.newDowntimeService = {
            type: 'OrderToDowntime',
            pathToClass: 'ru.itbrick.shustrikoffcrm.beans.OrderToDowntime',
            category: this.downtimeCategories[0],
            inKzn: true,
            date: this.orderDateTime
          }
        }
      }
    }
  },

  mounted () {
    api
      .getDowntimeCategories()
      .then(downtimeCategories => {
        if (downtimeCategories) {
          this.downtimeCategories = []
          this.downtimeCategories = downtimeCategories
        }
      })
  },

  methods: {
    saveChanges () {
      let promise
      if (this.isNew) {
        promise = this.addNewService()
      } else {
        promise = this.updateService()
      }
      this.$store.commit('addNewGroupedServicesPromise', promise)
      this.$emit('close-window', false)
    },

    updateService () {
      // при коммите в store index из property является undefined
      let index = this.index
      let count = this.count
      let serviceData = {
        category: this.downtimeService.category,
        inKzn: this.downtimeService.inKzn
      }

      return new Promise(resolve => {
        this.$store.dispatch('updateGroupedServiceByIndex', {
          index: index,
          count: count,
          serviceData: serviceData
        }).then(() => resolve())
      })
    },

    addNewService () {
      // Вместо запрета добавляем к счётчику уже добавленной услуги
      // if (this.$store.getters.groupedServices
      //   .filter(gs => gs[0].type === 'OrderToDowntime'
      //     && gs[0].inKzn === this.currentService.inKzn).length > 0) {
      //   alert('Услуга суток простоя в этом месте уже добавлена')
      //   return
      // }

      return new Promise(resolve => {
        utils.spotRegionAndDistrictByAddresses(this.$store.getters.addresses, this.$store.getters.regions, this.$store.getters.districts)
          .then(regionDistrictData => {
            Object.assign(this.newDowntimeService, regionDistrictData)

            let groupedService = []
            for (let i = 0; i < this.count; i++) { groupedService.push(Object.assign({}, this.newDowntimeService)) }

            this.$store.dispatch('addNewGroupedService', groupedService).then(() => resolve())
          })
        this.newDowntimeService.clientTime = 24 * 60 * 60 * 1000
      })
    }
  }
}
</script>
